import { AppAreaConfig } from '@/funnels/@types'
import femaleWaterFasting from './female-water-fasting'
import maleWaterFasting from './male-water-fasting'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-water-fasting',
	landing: {
		ids: ['loader-water-balance-f', 'age-main'],
		route: {
			path: '/water-fasting',
			name: 'main-water-fasting-funnel',
		},
	},
	funnel: {
		id: 'ob-universal-water-fasting',
		route: {
			path: '/water-fasting/ob/:page(.*)?',
			name: 'main-water-fasting',
		},
		slug: 'main-water-fasting',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleWaterFasting },
				female: { appArea: femaleWaterFasting },
			},
		},
	},
}

export default appAreaConfig
